//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavHelpFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2C6.49 2 2 6.49 2 12ZM12.01 18.25C11.32 18.25 10.76 17.69 10.76 17C10.76 16.31 11.32 15.75 12.01 15.75C12.7 15.75 13.26 16.31 13.26 17C13.26 17.69 12.7 18.25 12.01 18.25ZM12.36 6.13C14.44 6.15 16.06 7.4 16.22 9.09C16.35 10.43 15.52 12.06 12.88 12.82V14.5H11.13L11.12 11.42L11.82 11.28C13.51 10.93 14.56 10.14 14.47 9.27C14.41 8.61 13.64 7.9 12.33 7.89C12.31 7.89 12.3 7.89 12.28 7.89C11.01 7.89 9.99 8.39 9.36 8.79V6.8C10.14 6.44 11.12 6.14 12.28 6.14C12.31 6.13 12.33 6.13 12.36 6.13Z" fill="currentColor" /></svg>;
}
export default IconNavHelpFill;